"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const config_1 = require("@completeanatomy/config");
const user_1 = require("@completeanatomy/user");
const hooks_1 = require("../../hooks");
const organisms_1 = require("../../organisms");
// eslint-disable-next-line max-lines-per-function
function GroupsListItem({ group, selected, className, onSelect, isMobile, }) {
    const config = (0, config_1.useConfigService)();
    const imageBaseUrl = (config === null || config === void 0 ? void 0 : config.get('AWS_SERVER_S3_USERDATA')) || '';
    const [deleteDialogOpen, setDeleteDialogOpen] = (0, react_1.useState)(false);
    const [leaveDialogOpen, setLeaveDialogOpen] = (0, react_1.useState)(false);
    const [editDialogOpen, setEditDialogOpen] = (0, react_1.useState)(false);
    const sharingService = (0, hooks_1.useSharing)();
    const currentUser = (0, user_1.useUser)();
    const onEdit = () => {
        setEditDialogOpen(true);
    };
    const onDelete = () => {
        setDeleteDialogOpen(true);
    };
    const onLeave = () => {
        setLeaveDialogOpen(true);
    };
    const onDeleteConfirm = () => {
        sharingService === null || sharingService === void 0 ? void 0 : sharingService.delete(group.identifier);
        setDeleteDialogOpen(false);
    };
    const onLeaveConfirm = () => {
        sharingService === null || sharingService === void 0 ? void 0 : sharingService.leaveGroup({
            group: group.identifier,
            to_user_id: currentUser === null || currentUser === void 0 ? void 0 : currentUser.identifier,
        });
        setLeaveDialogOpen(false);
    };
    const onCloseDialog = () => {
        setDeleteDialogOpen(false);
        setEditDialogOpen(false);
        setLeaveDialogOpen(false);
    };
    const renderButtons = () => {
        if (group.isFounder) {
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Button, { onClick: onEdit, "data-e2e": 'GroupsListItem_Button', children: (0, jsx_runtime_1.jsx)(ButtonIcon, { name: ui_1.Icons.Edit2, "data-e2e": 'GroupsListItem_ButtonIcon' }) }), (0, jsx_runtime_1.jsx)(Button, { onClick: onDelete, "data-e2e": 'GroupsListItem_Button', children: (0, jsx_runtime_1.jsx)(ButtonIcon, { name: ui_1.Icons.Delete, "data-e2e": 'GroupsListItem_ButtonIcon' }) })] }));
        }
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [group.isAdmin && ((0, jsx_runtime_1.jsx)(Button, { onClick: onEdit, "data-e2e": 'GroupsListItem_Button', children: (0, jsx_runtime_1.jsx)(ButtonIcon, { name: ui_1.Icons.Edit2, "data-e2e": 'GroupsListItem_ButtonIcon' }) })), (0, jsx_runtime_1.jsx)(Button, { onClick: onLeave, "data-e2e": 'GroupsListItem_Button', children: (0, jsx_runtime_1.jsx)(ButtonIcon, { name: ui_1.Icons.Clear, "data-e2e": 'GroupsListItem_ButtonIcon' }) })] }));
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Container, { className: className, onClick: () => onSelect(group), "$isMobile": isMobile, "data-e2e": 'GroupsListItem_Container', children: [(0, jsx_runtime_1.jsx)(GroupAvatar, { image: group.avatar ? imageBaseUrl + group.avatar : undefined, group: true, "data-e2e": 'GroupsListItem_GroupAvatar' }), (0, jsx_runtime_1.jsx)(Name, { selected: selected, "data-e2e": 'GroupsListItem_Name', children: group.name }), !isMobile && (0, jsx_runtime_1.jsx)(ButtonsContainer, { "data-e2e": 'GroupsListItem_ButtonsContainer', children: renderButtons() })] }), !isMobile && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(organisms_1.DeleteGroupDialog, { isOpen: deleteDialogOpen, groupName: (group === null || group === void 0 ? void 0 : group.name) || '', onDelete: onDeleteConfirm, onCancel: onCloseDialog, "data-e2e": 'GroupsListItem_DeleteGroupDialog' }), (0, jsx_runtime_1.jsx)(organisms_1.LeaveGroupDialog, { isOpen: leaveDialogOpen, groupName: (group === null || group === void 0 ? void 0 : group.name) || '', onLeave: onLeaveConfirm, onCancel: onCloseDialog, "data-e2e": 'GroupsListItem_LeaveGroupDialog' }), (0, jsx_runtime_1.jsx)(ui_1.Popup, { isOpen: editDialogOpen, onClose: onCloseDialog, showCross: true, "data-e2e": 'GroupsListItem_Popup', children: (0, jsx_runtime_1.jsx)(organisms_1.EditGroup, { group: group, "data-e2e": 'GroupsListItem_EditGroup' }) })] }))] }));
}
exports.default = GroupsListItem;
const Container = styled_components_1.default.div `
  display: flex;

  box-sizing: border-box;

  width: 100%;
  height: 60px;

  padding: 13px;

  border-bottom: ${({ $isMobile, theme }) => $isMobile ? 'none' : `1px solid ${theme.secondary}`};

  cursor: pointer;
`;
const GroupAvatar = (0, styled_components_1.default)(ui_1.Avatar) `
  flex-shrink: 0;

  width: 30px;
  height: 30px;

  margin: auto 15px auto 15px;

  color: ${props => props.theme.sharing.avatar.fill};

  background-color: ${props => props.theme.sharing.avatar.background};
`;
const Name = styled_components_1.default.div `
  margin: auto 15px auto 0;

  color: ${props => props.theme.text};

  font-weight: ${props => (props.selected ? 'bold' : 'normal')};
  font-size: 14px;
`;
const ButtonsContainer = styled_components_1.default.div `
  display: flex;

  margin: 0 0 0 auto;
`;
const Button = styled_components_1.default.div `
  display: flex;
  flex-shrink: 0;

  width: 30px;
  height: 100%;

  margin: 0 10px 0 0;

  cursor: pointer;
`;
const ButtonIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 20px;
  height: 20px;

  margin: auto;

  color: ${props => props.theme.sharing.buttonIcon};
`;
